import {TERMS_OF_SERVICE_PATH_PATTERN} from './page.js'

export const USER_CONSENT_STORAGE_KEY = 'fsc'

export const USER_CONSENTS = {
  FINANCIAL_SERVICES: 'financial_services',
  WHATSAPP_COMMUNICATIONS_C2B: 'whatsapp_communications_C2B',
  PORTAL_ANNOUNCEMENTS: 'portal_announcements',
  EXTERNAL_SERVICES_OFFERS: 'external_services_offers',
  SEGMENTED_ADS: 'segmented_ads'
}

export const ENABLED_USER_PROFILE_CONSENTS = [
  USER_CONSENTS.PORTAL_ANNOUNCEMENTS,
  USER_CONSENTS.WHATSAPP_COMMUNICATIONS_C2B,
  USER_CONSENTS.FINANCIAL_SERVICES,
  USER_CONSENTS.EXTERNAL_SERVICES_OFFERS,
  USER_CONSENTS.SEGMENTED_ADS
]

/**
 * @enum Lead hit type
 */
export const LEAD_HIT_TYPES = {
  VIEW_AD_PHONE: 1,
  VIEW_DEALER_PHONE: 2,
  CALL_AD: 3,
  CALL_DEALER: 4
}

export const SUBSCRIPTIONS = {
  EXTERNAL_SERVICES_OFFERS: 'external_services_offers',
  PORTAL_ANNOUNCEMENTS: 'portal_announcements'
}

export const USER_PHONE_VERIFICATION_ERROR_CODES = {
  PHONE_ALREADY_VERIFIED_BY_CURRENT_USER: 'PHONE_ALREADY_VERIFIED',
  PHONE_ALREADY_VERIFIED_BY_OTHER_USER: 'USER_PHONE_ALREADY_VERIFIED_BY_OTHER_USER',
  PHONE_VERIFICATION_ATTEMPTS_ERROR: 'PHONE_VERIFICATION_ATTEMPTS_ERROR',
  PHONE_VERIFICATION_ERROR: 'PHONE_VERIFICATION_ERROR'
}

export const CONSENT_LINK_PRICEDROP_ENABLED = true

export const DATA_MANAGEMENT_URL = 'https://ayuda.coches.net/hc/es/sections/6365567887250-Sobre-tus-datos'

export const CONSENT_EXTERNAL_SERVICES_INFO_URL = `${TERMS_OF_SERVICE_PATH_PATTERN}/#3-finalidades-de-tratamiento-y-bases-legales-de-legitimación`
export const CONSENT_FINANCIAL_SERVICES_INFO_URL = `${TERMS_OF_SERVICE_PATH_PATTERN}/#personal-data-handling`
export const CONSENT_SEGMENTED_ADS_INFO_URL = `${TERMS_OF_SERVICE_PATH_PATTERN}/#7-publicidad-personalizada`

export const ACCOUNT_VERIFICATION_REMINDER_ENABLED = true

export const UPDATE_USER_AVATAR_ENABLED = true

export const USER_PHONE_VERIFICATION_ENABLED = true

export const PROFESSIONAL_SELLER_LOGIN_URL = 'https://pro.coches.net/login.aspx'
